<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="!isFormDisplayed()" hideToggle class="panel-list" [ngClass]="{ expanded: isFormDisplayed() }" [disabled]="true">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !isFormDisplayed(), 'events-active': isFormDisplayed() }"
            class="detail-header">
            <app-list-header
                [createRight]="false"
                titleText="Utilisateurs"
                createIconText="Ajouter un utilisateur"
                [buttonDisplayListVisible]="isTreeDisplayed()"
                [buttonDisplayTreeVisible]="isListDisplayed()"
                (exported)="onUsersExported()"
                (helped)="onUsersHelped()"
                (listDisplayed)="setDisplayMode(DisplayMode.List)"
                (treeDisplayed)="setDisplayMode(DisplayMode.Tree)"></app-list-header>
        </mat-expansion-panel-header>

        @if (isListDisplayed()) {
            <app-users-list
                (itemSelected)="onUserSelected($event)"
                (itemDisplayed)="onUserDisplayed($event)"
                (itemEdited)="onUserEdited($event)"
                (itemReseted)="onUserReseted($event)"></app-users-list>
        } @else {
            <app-groups-tree
                [isDisplayUser]="true"
                (userDisplayed)="onUserDisplayed($event)"
                (userEdited)="onUserEdited($event)"
                (userReseted)="onUserReseted($event)"></app-groups-tree>
        }
    </mat-expansion-panel>

    @if (isFormDisplayed()) {
        <mat-expansion-panel [expanded]="isFormDisplayed()" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.userContext.item.displayName"
                    [id]="context?.userContext.item.id"
                    (displayed)="onUserDisplayed(context?.userContext.item)"
                    (edited)="onUserEdited(context?.userContext.item)"
                    (helped)="onUsersHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-user-detail
                [context]="context"
                (userUpdated)="userUpdated($event)"
                (paramsValuesUpdated)="paramsValuesUpdated($event)"
                (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                (viewsAccessibilitiesUpdated)="onViewsAccessibilitiesUpdated($event)"
                (canceled)="onBackToList()"></app-user-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
